var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBitbay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1984.3 1984.3",
    width: 30,
    height: 30,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#188dbe}.st1{fill:#fff}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 992.2,
    cy: 992.2,
    r: 992.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M676.2 1464.5v-202.2H334.5v-223h341.7v-525h535.4c213.9 12.5 370.1 262.5 133.8 420 291.4 160.9 97.1 530.2-133.8 530.2H676.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1127 892.3c84.7-18.2 149.6-123.4 11-191.6H915v191.6h217.2m-205.4 154.6h245.1c152 77.2 80.7 194.9-12.2 215.4H926.8V1043"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitbay);
export default __webpack_public_path__ + "static/media/bitbay.7bfa97a02e98bc2cfa919c148d67f43e.svg";
export { ForwardRef as ReactComponent };